/* eslint-disable no-nested-ternary */
import React, { memo, ReactElement, useMemo } from 'react';

import { Col, Form, Row, TypographyText } from '@components/atoms';
import InputField from '@components/molecules/InputField';
import { codeMap } from '@constants/code';
import { TAnswer } from '@constants/enum';
import { TEXT_AREA_PLACEHOLDER } from '@constants/text';
import { useReduxForm } from '@hooks/useReduxForm';
import _ from 'lodash';

import Onset from './Onset';
import Scale from './Scale';

function Radio({ formKey, answers }: { formKey: string; answers: TAnswer[] }): ReactElement {
  const { form, formData, setFormData, formFieldsError, validationChecker } = useReduxForm('survey');
  const { surveyType } = formData ?? {};

  const b2cFlag = useMemo(() => surveyType === 'B2C', [surveyType]);

  return (
    <Row gutter={[0, 5]} style={{ rowGap: '6px' }}>
      {(b2cFlag ? answers.filter(({ value }) => value !== -1) : answers).map(({ value, label, next }) => (
        <>
          <Col
            onClick={() => {
              const body = {
                [formKey]: value,
              };
              // 하위 Onset Scale 설문 응답 초기화
              answers.forEach((a) => {
                if (a.next !== undefined) {
                  const nextArr = _.isArray(a.next) ? a.next : [a.next]; // nextArr type: string[]
                  const ScaleOnsetSurvey = nextArr.filter((n: string) =>
                    ['Scale', 'Onset'].includes(codeMap.get(n)?.selectType as string),
                  );
                  ScaleOnsetSurvey.forEach((n: string) => {
                    if (codeMap.get(n)?.selectType === 'Scale') {
                      // @ts-ignore
                      body[n] = undefined;
                    } else if (codeMap.get(n)?.selectType === 'Onset') {
                      // @ts-ignore
                      body[n] = undefined;
                    }
                  });
                }
              });

              if (next !== undefined) {
                // next 값이 있는 경우에만 다음 설문을 어디로 세팅할지 지정
                const nextArr = _.isArray(next) ? next : [next]; // nextArr type: string[]
                const ScaleOnsetSurvey = nextArr.filter((n: string) =>
                  ['Scale', 'Onset'].includes(codeMap.get(n)?.selectType as string),
                );
                const v = nextArr.filter(
                  (n: string) => !['Scale', 'Onset'].includes(codeMap.get(n)?.selectType as string),
                );
                // @ts-ignore
                body[`${formKey}Next`] = v?.length ? v : undefined;
                ScaleOnsetSurvey.forEach((n: string) => {
                  if (codeMap.get(n)?.selectType === 'Scale') {
                    // @ts-ignore
                    body[n] = { scale: 3 };
                  } else if (codeMap.get(n)?.selectType === 'Onset') {
                    // @ts-ignore
                    body[n] = { onset: 0 };
                  }
                });
              } else {
                body[`${formKey}Next`] = 0;
              }
              setFormData(body);
            }}
            span={24}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            yzTypeCol={formData[formKey] === value ? 'selected-onset-button' : 'onset-button'}
          >
            <Row style={{ display: 'flex' }}>
              <TypographyText yzTypeTypographyText="basic">{label}</TypographyText>
            </Row>
          </Col>
          {!b2cFlag &&
            formData[formKey] === value &&
            codeMap.get(value as string)?.selectType === 'Scale' && <Scale value={value as string} />}
          {!b2cFlag &&
            formData[formKey] === value &&
            codeMap.get(value as string)?.selectType === 'Onset' && <Onset value={value as string} />}
          {!b2cFlag && formData[formKey] === -1 && value === -1 && (
            <Form
              form={form}
              initialValues={{ [`${formKey}Desc`]: formData?.[`${formKey}Desc`] ?? '' }}
              labelAlign="left"
              style={{ width: '100%' }}
            >
              <InputField
                borderTop={false}
                componentArray={[
                  {
                    type: 'textArea',
                    yzTypeTextArea: 'surveyItem',
                    placeholder: TEXT_AREA_PLACEHOLDER,
                    dataIndex: `${formKey}Desc`,
                    formData,
                    onChange: (e: any) => {
                      setFormData(`${formKey}Desc`, e);
                    },
                  },
                ]}
                formFieldsError={formFieldsError}
                validation={validationChecker}
              />
            </Form>
          )}
        </>
      ))}
    </Row>
  );
}

export default memo(Radio);
